/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type VehicleBrandRuleKind =
  (typeof VehicleBrandRuleKind)[keyof typeof VehicleBrandRuleKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleBrandRuleKind = {
  Supercar: 0,
  LowRangeElectric: 1,
} as const;
